import * as React from "react";

import { Button } from "@/components/ui/button";

/** Keep denied/stale financing queries from replacing the whole customer page. */
export class CreditKeyPanelBoundary extends React.Component<
  { children: React.ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="space-y-3 rounded-lg border p-4">
        <p role="alert" className="text-sm">
          Unable to load Credit Key status. Check your session and refresh the status before changing access or making another payment request.
        </p>
        <Button type="button" variant="outline" onClick={() => this.setState({ failed: false })}>
          Refresh status
        </Button>
      </div>
    );
  }
}
